
import React from "react";
import { Boxes } from "./background-boxes";
import { cn } from "../../lib/utils";
import { Button } from "./button";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "./select"


export function BackgroundBoxesDemo() {
  const handlePro = () =>{
    const projectsElement = document.getElementById('project');
    projectsElement.scrollIntoView({ behavior: 'smooth' });
  }
  const handleSoc = () =>{
    const projectsElement = document.getElementById('contact');
    projectsElement.scrollIntoView({ behavior: 'smooth' });
  }
  
  
  return (
    (<div
      className="h-[50vh] relative w-full overflow-hidden bg-background flex  items-center justify-center rounded-lg p-[12px] lg:p-[1px]">
      <div
        className="absolute inset-0 w-full h-full bg-background z-20 [mask-image:radial-gradient(transparent,white)] pointer-events-none" />
      <Boxes />

      <div className="flex flex-col gap-2 justify-center items-center">
      <h1 className={cn(" text-4xl font-semibold font-mono text-primary relative z-20 text-center")}>
Soyong.
      </h1>
      <p className="text-xl text-center">A front-end Dev and a Student</p>
      <p className=" mt-1 text-center -[75%] text-neutral-300 text-sm relative z-20">
   I am a commerce student completing my 12th grade and a front-end dev,i am really passionate about desgining andlearning new stuff related to front-end development.  
      </p>

      <div className=" mt-10 z-20 flex flex-row gap-2">
     <Button  className='text-purple-500 font-mono' onClick={handleSoc}>Contact me</Button>
     <Button variant='outline' className='text-lime-500 font-mono' onClick={handlePro}>View Porjects</Button>
     
      </div>
      <Select >
      <SelectTrigger  className="w-32 z-[20] bg-card font-mono">
        <SelectValue placeholder="Select a fruit" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Fruits</SelectLabel>
          <SelectItem value="apple">Apple</SelectItem>
          <SelectItem value="banana">Banana</SelectItem>
        
        </SelectGroup>
      </SelectContent>
    </Select>
    
      </div>
    
    </div>)
  );
}
